import { TABLES_API } from "../../../../constants/Configs"
import { dispatch } from "../../../../utils/store"
import { handleError, handleSuccess } from "../../../../utils/toast"
import { API_REQUEST } from "../../../../constants/General"
import { Actions } from "../../../../redux/actions"
import { tableListDTO } from "../dtos/tables"
import API from "../../../../services/api"
import { getPageSize } from "../../../../services/middleware"

export const getTables = (search, sortBy, orderBy, page = 1) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  const params = {
    ...(!!search ? { search } : {}),
    ...(!!sortBy ? { sortBy } : {}),
    ...(!!orderBy ? { orderBy } : {}),
    ...(!!page ? { page, 'size': getPageSize() } : {}),
  }

  API(API_REQUEST.get, TABLES_API, { params })
    .then(res => {
      dispatch(Actions.RestaurantAdminTables.SetTables, tableListDTO(res.data.data.rows))
      dispatch(Actions.RestaurantAdminTables.SetTotalCount, res.data.data.count)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const addTable = (search, activeSort, sortOrder, page, handleCloseModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.post, TABLES_API, {})
    .then((res) => {
      handleSuccess(res)
      handleCloseModal()
      getTables(search, activeSort, sortOrder, page)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch((error) => {
      handleError(error);
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const editTable = (id, data, search, activeSort, sortOrder, page, handleCloseModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.put, `${TABLES_API}/${id}`, data)
    .then(res => {
      handleSuccess(res)
      handleCloseModal()
      getTables(search, activeSort, sortOrder, page)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}

export const deleteTable = (search, activeSort, sortOrder, page, setShowDeleteModal) => {
  dispatch(Actions.RestaurantAdmin.SetLoading, true)
  API(API_REQUEST.delete, TABLES_API)
    .then(res => {
      handleSuccess(res)
      setShowDeleteModal(false)
      getTables(search, activeSort, sortOrder, page)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
    .catch(err => {
      handleError(err)
      dispatch(Actions.RestaurantAdmin.SetLoading, false)
    })
}